import React, { useEffect, useRef, useState } from "react";

function TrustWallet() {
  const shapeRef = useRef(null);
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!shapeRef.current) return;

      const rect = shapeRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight && rect.bottom > 0) {
        const scrollProgress = rect.top / windowHeight;
        setOffsetY(scrollProgress * 500); // adjust speed here
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <div className="team-style-two-area default-padding bottom-less">
        <div className="container">
          <div className="team-style-two-items">
            <div className="shape" ref={shapeRef}>
              <img
                src="https://validthemes.net/site-template/robok/assets/img/illustration/9.png"
                alt="Image Not Found"
                style={{
                  transform: `translateY(${offsetY}px)`,
                  transition: "transform 0.1s linear",
                }}
              />
            </div>
            <div className="row align-center">
              <div className="col-lg-6 col-md-6 mb-30">
                <div className="team-style-two-heading">
                  <h4 className="sub-title">Ai Developer</h4>
                  <h2 className="title split-text-right split-text-in-right">
                    Application Range with Substrate Blockchain Technology
                  </h2>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Trust Wallet</h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/6.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>MetaMask</h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/7.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Phantom</h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/8.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>TronLink</h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/9.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Coinbase Wallet</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-30">
                <div className="team-style-two-item fade-up-anim">
                  <div className="thumb">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                      alt="Image Not Found"
                    />
                  </div>
                  <div className="info">
                    <h4>Exodus Wallet</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TrustWallet;
